export default "__VITE_PUBLIC_ASSET__3bce9b87__"